// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"205":"post","636":"landing","846":"writer","966":"login"}[chunkId] + "-legacy." + {"205":"5b09b4bb","636":"99185d14","846":"42f25bad","966":"52864be1"}[chunkId] + ".js";
};